export default {
  name: 'res-label',
  props: {
    element: {
      type: Object,
      default: () => {}
    },
    content: {
      type: String,
      default: '这是提示内容'
    }
  },
  computed: {
    getLabelVal() {
      if (!this.element) return;
      return `<div>${this.element.label.replace(/\n*$/g, '').replace(/\n/g, '</div><div>')}</div>`;
    },

    styleWidth() {
      if (!this.element) return;
      let {
        labelWidth
      } = this.element;
      return {
        width: `${labelWidth}px`
      };
    }

  },

  data() {
    return {};
  },

  methods: {}
};